import { useNavigate } from "react-router-dom"
import { Footer } from "../../../Footer/Footer"
import { Header } from "../../../IndexPage/Header/Header"

export const DoGA = () => {
    const navigate = useNavigate()
    const handleReadmore = () => {
        navigate('/GeneralAverageClaimsReadmore')
    }
    return (
        <>
         <div className="container-fluid">
            <Header actives="GeneralAverageClaims" />
            <div className="container-fluid mt-lg-5  col-lg-11 mx-auto mt-5 pt-5" style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="row my-5  " style={{ backgroundColor: '#bdd1e169' }}>

                    <div className="px-5 col-lg-10 mx-auto pt-5" style={{ position: 'relative', textAlign: 'justify' }}>

                        {/* <h5 className="fw-bold green ps-lg-5">POST SABRINA PRESENTATION </h5> */}
                        <p className=" ps-lg-5">
                            There are certain misconceptions about the "Declaration of General Average". Let us have a look at the flow chart, which lists the numerous outstanding questions date while dealing with the General Average situation, claims and contributions.
                        </p>

                    </div>
                    <div className="col-12 col-lg-12 mb-0">
                        <div className="pt-2 pb-4 text-center ">
                            <img src="Static/Assets/Img/DoGA.png" alt="" className="img-fluid " style={{ height: "71vh", width: "66vw" }} />
                        </div>
                        <div className="pt-4 pb-2 text-center" >
                            MILSO is committed to the stakeholders of Maritime Industry to demystify the “General Average”  through consulting and trainings!


                            <p className="text-center pt-3" >
                                <button className="btn button py-3 px-5" onClick={handleReadmore}>
                                    <span> Read Less</span>
                                </button>
                            </p>
                        </div>
                    </div>



                </div>
            </div>
            <Footer />
            </div>
        </>
    )
}